import { useEffect, useState } from "react";
import elementResizeDetectorMaker from "element-resize-detector";

let erd;

export default function useGetElementSizeState(props) {
    const { initialSize, domElement, elementRef } = props;
    const [elementSize, setElementSize] = useState(initialSize);

    useEffect(() => {
        const actualElement = domElement || elementRef?.current;
        if (actualElement) {
            if (!erd) {
                erd = elementResizeDetectorMaker({
                    strategy: "scroll",
                });
            }
            const callBack = function (el) {
                setElementSize({
                    height: el.offsetHeight,
                    width: el.offsetWidth,
                });
            };
            erd.listenTo(actualElement, callBack);
            return () => {
                erd?.removeListener(callBack);
            };
        }
    }, [domElement, elementRef]);
    return [elementSize];
}
